import keyBy from 'lodash/keyBy';
import { UserStatus } from 'src/@types/user-status';
import type { IWorkspace } from 'src/@types/workspace';
import { UserType } from 'src/@types/workspace-info';
import type { IRole } from 'src/requests/roles.requests';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { WorkspaceInfoQueryData } from './hooks/common';
import type { WorkspaceInfoStore } from './interfaces';

export type WorkspaceInfoStoreApi = ReturnType<typeof workspaceInfoFactory>;

export const workspaceInfoFactory = () =>
  create(
    immer<WorkspaceInfoStore>((set) => ({
      workspace: {
        _id: '',
        slug: '',
        pendingInvites: [],
        users: [],
        name: '',
        owner: '',
        shortName: '',
        featureSettings: { smartTodos: false },
      },
      teams: [],
      usersById: {},
      teamsById: {},
      activeUsers: [],
      aiUser: {
        _id: '',
        email: '',
        name: '',
        picture: '',
        active: true,
        workspace: {} as IWorkspace,
        title: '',
        role: {} as IRole,
        status: UserStatus.ONLINE,
        lastAccess: '',
        customStatus: {},
        type: UserType.AI,
      },
      syncWorkspaceInfo: ({ workspace, teams }: WorkspaceInfoQueryData) => {
        set((state) => {
          state.workspace = workspace;
          state.usersById = keyBy(workspace.users, '_id');
          state.teamsById = keyBy(teams, '_id');
          state.activeUsers = workspace.users.filter(
            (user) => user.active === true,
          );
          const aiUser = workspace.users.find(
            (user) => user.type === UserType.AI,
          );
          if (aiUser) {
            state.aiUser = aiUser;
          }
        });
      },
    })),
  );
